import Vue from 'vue'
import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'


## Initialize firebase
config =
    apiKey: "AIzaSyDbyUWXlrfUY2vFKMb3mLPQ8fmWHvBawNQ"
    authDomain: "qreventsdemo.firebaseapp.com"
    databaseURL: "https://qreventsdemo.firebaseio.com"
    projectId: "qreventsdemo"
    storageBucket: "qreventsdemo.appspot.com"
    messagingSenderId: "27292983492"
    appId: "1:27292983492:web:bcf48783409983997de991"
firebase.initializeApp config


## User model - root fields must exist for Pug to not throw an error
user =
    id: ''
    email: ''
    admin: false
    details:
        address:
            country: ''


## Auth & load user
auth = firebase.auth()
auth.onAuthStateChanged (u) ->
    console.log "Local user: ", u?.uid
    Vue.set(user, 'id', u?.uid || '')
    Vue.set(user, 'email', u?.email || '')
    Vue.set user, 'admin', u?.uid?
    loadUser u if u?

loadUser = (u) ->
    u = auth.currentUser unless u?
    db = firebase.firestore()
    db.collection('users').doc(u.uid).get().then (doc) ->
        unless doc? then return
        unless doc?.exists then return
        Vue.set user, 'details', doc.data()
    .catch (e) ->
        console.log 'User eror: ', e


export { user }
export { loadUser }